export enum FileType {
    IMAGE = 'image',
    VIDEO = 'video',
    UNSUPPORTED = 'unsupported'
}
